import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import CustomNavbar from './components/CustomNavbar'
import {useEffect} from 'react'
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom'
import LandingPage from './pages/LandingPage'
import ContactPage from './pages/ContactPage'
import ServicesPage from './pages/ServicesPage'
import CennikPage from './pages/CennikPage'
import PediPage from './pages/PediPage'
import TeamPage from './pages/TeamPage'
import Logo from './images/Hands.svg';

function AppContent() {
  const location = useLocation();
  const navigate = useNavigate();

  function handleSetPage(path: string) {
    const element = document.getElementById("loadingScreen");
    element?.classList.add("loading");
    setTimeout(() => {
      navigate(path);
      setTimeout(() => element?.classList.remove("loading"), 500);
    }, 500);
  }

  useEffect(() => {
    const element = document.getElementById("loadingScreen");
    if (element) {
      element.classList.add("loading");
      setTimeout(() => element.classList.remove("loading"), 1000);
    }
  }, [location.pathname]);

  return (
    <div className="App">
      <div id='loadingScreen' className='loadingScreen'><img src={Logo} className="logo-loading" alt="earth-bg" /></div>
      <CustomNavbar setPage={handleSetPage}></CustomNavbar>
      <Routes>
        <Route path="/" element={<LandingPage setPage={handleSetPage} />} />
        <Route path="/sluzby" element={<ServicesPage handleFunction={handleSetPage} />} />
        <Route path="/o-nas" element={<TeamPage />} />
        <Route path="/cennik" element={<CennikPage />} />
        <Route path="/kontakt" element={<ContactPage />} />
        {/* <Route path="/pedikura" element={<PediPage />} /> */}
        <Route path="*" element={<LandingPage setPage={handleSetPage} />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
